import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Breadcrumbs } from '@/components/ui/Breadcrumbs';
import { useBreakpoint } from '@/hooks/useBreakpoint';

export const ResponsiveLayout: React.FC = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { isMobile, isTablet } = useBreakpoint();

    // Fechar sidebar automaticamente em mobile quando redimensionar para desktop
    useEffect(() => {
        if (!isMobile && sidebarOpen) {
            setSidebarOpen(false);
        }
    }, [isMobile, sidebarOpen]);

    // Fechar sidebar quando navegar em mobile
    const handleSidebarClose = () => {
        setSidebarOpen(false);
    };

    return (
        <div className="h-screen flex overflow-hidden bg-gray-50">
            {/* Sidebar */}
            <Sidebar
                isOpen={sidebarOpen}
                onClose={handleSidebarClose}
                isMobile={isMobile}
                isTablet={isTablet}
            />

            {/* Main Content */}
            <div className="flex flex-col flex-1 overflow-hidden">
                {/* Header */}
                <Header
                    onMenuClick={() => setSidebarOpen(true)}
                    isMobile={isMobile}
                />

                {/* Main Content Area */}
                <main className="flex-1 relative overflow-y-auto focus:outline-none">
                    <div className="py-3 sm:py-4 md:py-6">
                        <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
                            {/* Breadcrumbs - apenas em desktop */}
                            {!isMobile && <Breadcrumbs />}

                            {/* Page Content */}
                            <div className="mt-3 sm:mt-4 md:mt-6">
                                <Outlet />
                            </div>
                        </div>
                    </div>
                </main>
            </div>

            {/* Mobile Overlay */}
            {sidebarOpen && isMobile && (
                <div
                    className="fixed inset-0 z-40 bg-gray-600 bg-opacity-75 lg:hidden"
                    onClick={handleSidebarClose}
                />
            )}
        </div>
    );
};
